import React, { Component } from "react";
import { Link } from "react-router-dom";
export default class LoginForm extends Component {
  state = {
    email: "",
    password: "",
    isFormValid: false
  };
  _handleSubmit = event => {
    const { email, password } = this.state;
    const { onLogin } = this.props;
    event.preventDefault();
    onLogin({ email, password });
  };
  render() {
    const { email, password, isFormValid } = this.state;
    const { onCreateAccount } = this.props;
    return (
      <div class="dev-page-login-block__form">
        <form onSubmit={this._handleSubmit}>
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-user" />
              </span>
              <input
                type="text"
                class="form-control"
                value={email}
                onChange={event => {
                  this.setState({ email: event.target.value });
                }}
                placeholder="Login"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-lock" />
              </span>
              <input
                type="password"
                class="form-control"
                placeholder="Password"
                value={password}
                onChange={event => {
                  this.setState({ password: event.target.value });
                }}
              />
            </div>
          </div>
          <div class="form-group no-border margin-top-20">
            <button class="btn btn-success btn-block" type="submit">
              Login
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Login/LoginForm/index.js